import {
  Icon2fa,
  IconAccessPoint,
  IconAdCircle,
  IconAddressBook,
  IconAdjustmentsHorizontal,
  IconFile,
  IconFileAlert,
  IconFlower,
  IconHistory,
  IconMap,
  IconUser,
} from "@tabler/icons-react";
import { LinksGroupProps } from "../../_base/model/_base/LinksGroupProps";

export const _sideNavData: LinksGroupProps[] = [
  {
    label: "Biểu đồ",
    code: "dashboard",
    icon: IconMap,
    initiallyOpened: true,
    link: "/dashboard",
  },
  {
    label: "Phê duyệt",
    code: "tasks",
    icon: IconAccessPoint,
    initiallyOpened: true,
    link: "/method/approve-task",
  },
  {
    label: "Công việc của tôi",
    code: "tasks",
    icon: IconAdCircle,
    initiallyOpened: true,
    link: "/method/task-for-me",
  },
  {
    label: "Hồ sơ",
    code: "foldes",
    icon: IconFileAlert,
    initiallyOpened: true,
    link: "/method/folders-task",
  },
  {
    label: "Hồ sơ cũ",
    code: "folders-old",
    icon: IconFileAlert,
    initiallyOpened: true,
    link: "/method/folders-task-old",
  },
  {
    label: "Quản trị",
    code: "preferences",
    //  link: "/demo",
    icon: IconUser,
    initiallyOpened: false,
    links: [
      {
        label: "Tài khoản",
        link: "/manager/users",
        code: "users",
      },
      // {
      //   label: "Quy trình thực hiện",
      //   link: "/manager/flowchart-operation",
      // },
      {
        label: "Đơn vị",
        link: "/manager/organizations",
        code: "organizations",
      },
      {
        label: "Vai trò",
        link: "/manager/roles",
        code: "roles",
      },
      // {
      //   label: "Đối tác",
      //   link: "/manager/partners",
      // },
    ],
  },
  {
    label: "Quy trình",
    code: "process-defs",
    //  link: "/demo",
    icon: IconFlower,
    initiallyOpened: false,
    links: [
      {
        label: "Quy trình mẫu",
        link: "/process-defs/flow-model",
        code: "process-defs",
      },
      // {
      //   label: "Mẫu tài liệu",
      //   link: "/process-defs/document-model",
      // },
    ],
  },
  {
    label: "Hệ thống",
    code: "system",
    //  link: "/demo",
    icon: Icon2fa,
    initiallyOpened: false,
    links: [
      {
        label: "Công việc đang xử lý",
        link: "/system/process-task",
        code: "system",
      },
      {
        label: "Quá trình duyệt",
        link: "/system/process-instances",
        code: "system",
      },
      {
        label: "Loại tài liệu",
        link: "/system/document-type",
        code: "system",
      },
    ],
  },
  {
    label: "Admin",
    code: "admin",
    //  link: "/demo",
    icon: IconAddressBook,
    initiallyOpened: false,
    links: [
      // {
      //   label: "Mẫu Email",
      //   link: "/admin/email-model",
      // },
      // {
      //   label: "Giao diện",
      //   link: "/admin/design",
      // },
    ],
  },
  {
    label: "Lịch sử",
    code: "logs",
    //  link: "/demo",
    icon: IconHistory,
    initiallyOpened: false,
    links: [
      {
        label: "Trình ký",
        link: "/history/process-instances",
        code: "logs",
      },
      {
        label: "Hồ sơ",
        link: "/history/file",
        code: "logs",
      },
      {
        label: "Phê duyệt",
        link: "/history/task",
        code: "logs",
      },
      // {
      //   label: "Hệ thống",
      //   link: "/history/system",
      //   code: "logs",
      // },
    ],
  },
];
